import { useCallback } from 'react';
import { useTheme } from 'styled-components';
import { BackgroundImage, Image, withContent } from '@bubbletea/core';
import { IContent } from '../../../types';
import Title from '../../UI/Title';
import Button from '../../UI/Button';
import { ExternalIcon } from '../../UI/Icons';

import { SectionContainer, BackgroundContainer, Description, Content, Details, ImageContainer, Shape } from './styles';
import { IMainTheme } from '../../../types/theme';
import { IAdobeClickEvent } from '../../../types/tracking';
import sendEvent from '../../../utils/sendEvent';

interface ILatestUpdatesProps {
  context: IContent;
}

const LatestUpdates = ({ context }: ILatestUpdatesProps) => {
  const theme = useTheme() as IMainTheme;
  const { latestUpdates, global } = context.googlesheet;
  const { learnMore } = global;
  const { title, description, latestUpdatesButton } = latestUpdates;

  const followLink = useCallback(() => {
    if (latestUpdatesButton?.link) {
      const eventDetails: IAdobeClickEvent = {
        location: 'latest news',
        category: 'action',
        locationPosition: 3,
        action: 'latest news : learn more',
      };
      sendEvent(eventDetails);
      if (latestUpdatesButton?.target !== '_self') {
        window.open(latestUpdatesButton.link as string, latestUpdatesButton.target as string);
      } else {
        window.location.href = latestUpdatesButton.link as string;
      }
    }
  }, []);

  const impressionEventDetails: IAdobeClickEvent = {
    location: 'latest news',
    category: 'scroll',
    locationPosition: 3,
    action: 'visible',
  };

  return latestUpdatesButton.link ? (
    <SectionContainer
      id={'latest_updates'}
      whileInView={'sendevent'}
      onAnimationStart={() => sendEvent(impressionEventDetails, 'impressionevent')}
      viewport={{ once: true }}
    >
      <BackgroundContainer>
        <BackgroundImage
          imageNames={[`bg-latest-updates-${theme.name}.png`]}
          classNames={['bg-latest-updates']}
          dynamic
        />
        <BackgroundImage imageNames={['pattern-latest-updates.svg']} classNames={['pattern-latest-updates']} dynamic />
        <Shape />
        <Image imageNames={['image-latest-updates.png']} altText={''} classNames={['mobile-image']} dynamic />
      </BackgroundContainer>
      <div className={'section-wrapper'}>
        <Content>
          <ImageContainer
            initial={{
              opacity: 0,
              x: -50,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
            }}
            transition={{
              type: 'spring',
              delay: 0.2,
            }}
            viewport={{ once: true }}
          >
            <Image imageNames={['image-latest-updates.png']} altText={''} dynamic />
          </ImageContainer>
          <Details>
            <Title as={'h2'} textAlign={'left'}>
              {title}
            </Title>
            <Description>{description}</Description>
            <Button type={'outlined'} handleClick={() => followLink()}>
              {learnMore}
              {latestUpdatesButton.target !== '_self' ? <ExternalIcon /> : null}
            </Button>
          </Details>
        </Content>
      </div>
    </SectionContainer>
  ) : null;
};

export default withContent(LatestUpdates);
